import styled from 'styled-components'

interface DuplicateWarningMessageProps {
  style?: React.CSSProperties;
}

/** Horizontal scroll below 1200px so flex columns are not crushed. */
export const TableScroll = styled.div`
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;

  @media (max-width: 1199px) {
    /* uiKit Table root (tableWrapper) — keep QCS column layout scrollable */
    & > div {
      min-width: 1200px;
    }
  }
`

export const DuplicateWarningMessage = styled.div<DuplicateWarningMessageProps>`
  ${({ style }) => ({ ...style })};
  font-size: ${({ style }) => style?.fontSize || '12px'};
  font-style: ${({ style }) => style?.fontStyle || 'normal'};
  font-weight: ${({ style }) => style?.fontWeight || '400'};
  line-height: ${({ style }) => style?.lineHeight || 'normal'};
  color: ${({ style }) => style?.color || 'var(--color-text-error)'};
  top: ${({ style }) => style?.top || '62px'};
  left: ${({ style }) => style?.left || '72px'};
  width: ${({ style }) => style?.width || '220px'};
  word-break: ${({ style }) => style?.wordBreak || 'break-word'};
`
